"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import { NavLink } from "react-bootstrap";

const styles = new Proxy({"GradientBg":"GradientBg-5a081","GradientButton":"GradientButton-5a081","Navbar":"Navbar-5a081","scrolled":"scrolled-5a081","logoSmall":"logoSmall-5a081","Dropdown":"Dropdown-5a081","Logo":"Logo-5a081","menuBtn":"menuBtn-5a081","navToggler":"navToggler-5a081"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import phone from "./phone.svg";
import Link from "next/link";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const className = [
    "nav navbar fixed-top navbar-expand-lg navbar-dark",
    styles.Navbar,
    scrolled ? styles.scrolled : "",
  ].join(" ");

  const navToggler = ["d-block d-lg-none", styles.navToggler].join(" ");

  const onlyDesktop = ["d-none d-lg-block", styles.onlyDesktop].join(" ");

  const onlyMobile = ["d-block d-lg-none", styles.onlyMobile].join(" ");

  return (
    <nav className={className}>
      <div className="container">
        <NavLink href="/" className={styles.Logo}>
          <img
            src="/images/graboxy/logo.svg"
            alt="Graboxy Navbar Logo"
            className={scrolled ? styles.logoSmall : ""}
            style={{
              marginBottom: "-5px",
              width: scrolled ? "180px" : "234px",
            }}
          />
        </NavLink>

        <NavLink href="/" className={onlyDesktop}>
          <span className={styles.menuBtn}>Home</span>
        </NavLink>

        <div className={onlyDesktop}>
          <div className={styles.Dropdown}>
            <Link href="/#ZeroTrustSection">
              <span className={styles.menuBtn}>Solutions</span>
            </Link>
            <ul>
              <li>
                <NavLink href="/solutions/continuous-authentication">
                  Continuous Authentication
                </NavLink>
                <NavLink href="/solutions/multi-factor-authentication">
                  Silent 2FA
                </NavLink>
                <NavLink href="/solutions/device-fingerprinting">
                  Device Fingerprinting
                </NavLink>
                <NavLink href="/solutions/remote-desktop-detection">
                  Remote Desktop Detection
                </NavLink>
                <NavLink href="/solutions/captcha-bot-detection">
                  CAPTCHA & Bot Detection
                </NavLink>
                <NavLink href="/solutions/chrome-extension">
                  Chrome Extension
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <NavLink href="/technology" className={onlyDesktop}>
          <span className={styles.menuBtn}>Technology</span>
        </NavLink>

        <NavLink href="/blog" target="_blank" className={onlyDesktop}>
          <span className={styles.menuBtn}>Blog</span>
        </NavLink>

        <NavLink href="/our-team" className={onlyDesktop}>
          <span className={styles.menuBtn}>Team</span>
        </NavLink>

        <button
          className={navToggler}
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded={navOpen}
          aria-label="Toggle navigation"
          onClick={() => setNavOpen((prev) => !prev)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div
          className={["collapse navbar-collapse", navOpen ? "show" : ""].join(
            " ",
          )}
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ms-auto mt-3 mb-4 my-lg-0">
            <li className="nav-item">
              <Link
                href="/#ZeroTrustSection"
                style={{
                  color: "#f8e3ff",
                  fontSize: "calc(1.3rem + 0.6vw)",
                  textTransform: "none",
                  fontWeight: "400",
                }}
                className={onlyMobile}
              >
                Solutions
              </Link>
              <ul>
                <li>
                  <NavLink
                    href="/solutions/continuous-authentication"
                    className={onlyMobile}
                  >
                    Continuous Authentication
                  </NavLink>
                  <NavLink
                    href="/solutions/multi-factor-authentication"
                    className={onlyMobile}
                  >
                    Silent 2FA
                  </NavLink>
                  <NavLink
                    href="/solutions/device-fingerprinting"
                    className={onlyMobile}
                  >
                    Device Fingerprinting
                  </NavLink>
                  <NavLink
                    href="/solutions/remote-desktop-detection"
                    className={onlyMobile}
                  >
                    Remote Desktop Detection
                  </NavLink>
                  <NavLink
                    href="/solutions/captcha-bot-detection"
                    className={onlyMobile}
                  >
                    CAPTCHA & Bot Detection
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <NavLink
                href="/technology"
                className={onlyMobile}
                style={{
                  color: "#f8e3ff",
                  fontSize: "calc(1.3rem + 0.6vw)",
                  textTransform: "none",
                  fontWeight: "400",
                }}
              >
                Technology
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                href="/blog"
                target="_blank"
                className={onlyMobile}
                style={{
                  color: "#f8e3ff",
                  fontSize: "calc(1.3rem + 0.6vw)",
                  textTransform: "none",
                  fontWeight: "400",
                }}
              >
                Blog
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                href="/our-team"
                className={onlyMobile}
                style={{
                  color: "#f8e3ff",
                  fontSize: "calc(1.3rem + 0.6vw)",
                  textTransform: "none",
                  fontWeight: "400",
                }}
              >
                Team
              </NavLink>
            </li>
            <li className="nav-item">
              <Link
                href="#submit"
                className="btn"
                style={{ padding: "10px 30px" }}
              >
                Contact Us{" "}
                <Image src={phone.src} alt="phone" width={20} height={20} />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
